import { DaVinciCatapult } from "./DaVinciCatapult";
import "./index.css";

export function App() {
	return <DaVinciCatapult />;
}

export default App;
